function validation(value, t) {
  const errors = {};
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const numberPattern = /^[0-9]+$/;
  const phonePattern = /^\+?\d+$/;

  // fallback text if t is not provided
  const translate = (text) => {
    if (typeof t !== "function") {
      return text;
    }
    return t(text);
  };

  const validateField = (fieldName, errorMessage) => {
    if (value[fieldName] === undefined) return;
    if (!value[fieldName]) {
      errors[fieldName] = errorMessage;
    }
  };

  const validateEmail = () => {
    if (value.email === undefined) return;
    if (value.email === "") {
      errors.email = translate("Please_Enter_Your_Email");
    } else if (!emailPattern.test(value.email)) {
      errors.email = translate("Invalid_Email_Format");
    }
  };

  const validateNumber = () => {
    if (value.weight === undefined) return;
    if (value.weight === "") {
      errors.weight = translate("Please_Enter_Weight_In_Number");
    } else if (!numberPattern.test(value.weight)) {
      errors.weight = translate("Should_Contain_Only_Numbers");
    }
  };

  /*
  // Delete this comment once the phone number validation is finalized
  const validatePhoneNumber = () => {
    if (value.phoneNumber === undefined) return;
    if (value.phoneNumber === "") {
      errors.phoneNumber = translate("Please_Enter_Your_Phone_Number");
    } else if (!phonePattern.test(value.phoneNumber)) {
      errors.phoneNumber = translate(
        "Phone_Number_Should_Contain_Only_Numbers"
      );
    } else if (value.phoneNumber.length > 15) {
      errors.phoneNumber = translate(
        "Phone_Number_Should_Not_Exceed_15_Digits"
      );
    }
  };
  */

  const validatePhoneNumber = () => {
    if (value.phoneNumber === undefined) return;

    const raw = value.phoneNumber.trim();
    const normalized = raw
      .replace(/^\+?966/, "")
      .replace(/^00/, "")
      .replace(/^0/, "")
      .replace(/\s+/g, "");

    if (!raw) {
      errors.phoneNumber = translate("Please_Enter_Your_Phone_Number");
    } else if (!/^\d+$/.test(normalized)) {
      errors.phoneNumber = translate(
        "Phone_Number_Should_Contain_Only_Numbers"
      );
    } else if (!/^5\d{8}$/.test(normalized)) {
      errors.phoneNumber = translate("Please_Enter_Valid_Saudi_Phone_Number");
    }
  };

  const validateZipCode = () => {
    if (value.zipCode === undefined) return;
    if (value.zipCode === "") {
      errors.zipCode = translate("Please_Enter_Your_Zipcode");
    } else if (!numberPattern.test(value.zipCode)) {
      errors.zipCode = translate("Postal_Code_Should_Contain_Only_Numbers");
    } else if (value.zipCode.length > 5) {
      errors.zipCode = translate("Postal_Code_Should_Not_Exceed_5_Digits");
    }
  };

  validateField("firstName", translate("Please_Enter_First_Name"));
  validateField("lastName", translate("Please_Enter_Last_Name"));
  validateField("country", translate("Please_Enter_Your_Country"));
  validateField("city", translate("Please_Select_Your_City"));
  validateField("state", translate("Please_Enter_Your_State"));
  validateField("line1", translate("Please_Enter_Your_Address"));
  validateField("promoCode", translate("Please_Enter_Promo_Code"));
  validateField("username", translate("Please_Enter_Your_Username"));
  validateField("password", translate("Please_Enter_Your_Password"));
  validateField("street", translate("Please_Enter_Your_Street_Name"));
  validateField("confirm", translate("Please_Confirm_Your_Password"));
  // Customer Reviews
  validateField("review", translate("Please_Enter_Your_Review_Comment"));
  validateField("rating", translate("Please_Select_Your_Rating"));
  // Change Password Form
  validateField("oldPassword", translate("Please_Enter_Your_Old_Password"));
  validateField("newPassword", translate("Please_Enter_Your_New_Password"));
  validateField(
    "confirmNewPassword",
    translate("Please_Confirm_Your_Password")
  );
  // Check if newPassword and confirmPassword match
  if (
    value.newPassword &&
    value.confirmNewPassword &&
    value.newPassword !== value.confirmNewPassword
  ) {
    errors.confirmNewPassword = translate(
      "New_Password_And_Confirm_Password_Do_Not_Match"
    );
  }
  // Cancel Order Form
  validateField("selectreason", translate("Please_Select_Your_Reason"));

  // Contact Form
  validateField("name", translate("Please_Enter_Your_Name"));
  validateField("message", translate("Please_Enter_Your_Message"));

  validateEmail();
  validatePhoneNumber();
  validateNumber();
  validateZipCode();

  return errors;
}

export default validation;
